export default __webpack_public_path__ + "static/media/vector-order-button.078902f0.svg";